<template>
  <div class="app-container">
    <div class="filter-container">
      <el-button type="primary" @click="handleAdd">添加用户</el-button>
    </div>

    <el-table
      v-loading="loading"
      :data="userList"
      style="width: 100%"
      border>
      <el-table-column
        prop="username"
        label="用户名"
        width="120"
        align="center">
      </el-table-column>
      <el-table-column
        prop="name"
        label="姓名"
        width="120"
        align="center">
      </el-table-column>
      <el-table-column
        prop="sex"
        label="性别"
        width="80"
        align="center">
        <template slot-scope="scope">
          {{ scope.row.sex === '1' ? '男' : '女' }}
        </template>
      </el-table-column>
      <el-table-column
        prop="birthday"
        label="生日"
        width="120"
        align="center">
      </el-table-column>
      <el-table-column
        prop="role"
        label="角色"
        width="100"
        align="center">
        <template slot-scope="scope">
          {{ scope.row.role === 0 ? '管理员' : '普通用户' }}
        </template>
      </el-table-column>
      <el-table-column
        prop="status"
        label="状态"
        width="100"
        align="center">
        <template slot-scope="scope">
          <el-tag :type="scope.row.status === 1 ? 'success' : 'danger'">
            {{ scope.row.status === 1 ? '启用' : '禁用' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column
        prop="total_score"
        label="积分"
        width="120"
        align="center">
        <template slot-scope="scope">
          <el-tooltip 
            content="点击查看积分详情" 
            placement="top"
            :disabled="!scope.row.total_score">
            <el-button 
              type="text" 
              @click="handleViewScore(scope.row)"
              :disabled="!scope.row.total_score"
              style="color: #409EFF; font-weight: bold;">
              {{ scope.row.total_score || 0 }}
            </el-button>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        align="center">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="info"
            @click="handleExport(scope.row)">数据导出</el-button>
          <el-button
            size="mini"
            type="success"
            @click="handleEdit(scope.row)">编辑</el-button>
          <el-button
            size="mini"
            type="primary"
            @click="handleEditPassword(scope.row)">修改密码</el-button>
          <el-button
            size="mini"
            :type="scope.row.status === 1 ? 'warning' : 'success'"
            @click="handleToggleStatus(scope.row)">
            {{ scope.row.status === 1 ? '禁用' : '启用' }}
          </el-button>
          <el-button
            size="mini"
            type="danger"
            @click="handleDelete(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 添加用户对话框 -->
    <el-dialog
      title="添加用户"
      :visible.sync="addDialogVisible"
      width="500px"
      center
      :close-on-click-modal="false"
      append-to-body>
      <el-form
        ref="addForm"
        :model="addForm"
        :rules="addFormRules"
        label-width="100px">
        <el-form-item label="用户名" prop="username">
          <el-input v-model="addForm.username" ref="usernameInput"></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <el-input v-model="addForm.password" type="password"></el-input>
        </el-form-item>
        <el-form-item label="姓名" prop="name">
          <el-input v-model="addForm.name"></el-input>
        </el-form-item>
        <el-form-item label="性别" prop="sex">
          <el-radio-group v-model="addForm.sex">
            <el-radio label="1">男</el-radio>
            <el-radio label="2">女</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="生日" prop="birthday">
          <el-date-picker
            v-model="addForm.birthday"
            type="date"
            placeholder="选择日期"
            value-format="yyyy-MM-dd">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="角色" prop="role">
          <el-radio-group v-model="addForm.role">
            <el-radio :label="0">管理员</el-radio>
            <el-radio :label="1">普通用户</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="addDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitAdd">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 修改密码对话框 -->
    <el-dialog
      title="修改密码"
      :visible.sync="passwordDialogVisible"
      width="500px"
      center
      :close-on-click-modal="false"
      append-to-body>
      <el-form
        ref="passwordForm"
        :model="passwordForm"
        :rules="passwordFormRules"
        label-width="100px">
        <el-form-item label="新密码" prop="password">
          <el-input v-model="passwordForm.password" type="password" ref="passwordInput"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="passwordDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitPassword">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 编辑用户对话框 -->
    <el-dialog
      title="编辑用户"
      :visible.sync="editDialogVisible"
      width="500px"
      center
      :close-on-click-modal="false"
      append-to-body>
      <el-form
        ref="editForm"
        :model="editForm"
        :rules="editFormRules"
        label-width="100px">
        <el-form-item label="用户名">
          <el-input v-model="editForm.username" disabled></el-input>
        </el-form-item>
        <el-form-item label="姓名" prop="name">
          <el-input v-model="editForm.name" ref="nameInput"></el-input>
        </el-form-item>
        <el-form-item label="性别" prop="sex">
          <el-radio-group v-model="editForm.sex">
            <el-radio label="1">男</el-radio>
            <el-radio label="2">女</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="生日" prop="birthday">
          <el-date-picker
            v-model="editForm.birthday"
            type="date"
            placeholder="选择日期"
            value-format="yyyy-MM-dd">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="角色" prop="role">
          <el-radio-group v-model="editForm.role">
            <el-radio :label="0">管理员</el-radio>
            <el-radio :label="1">普通用户</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="editDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitEdit">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 数据导出对话框 -->
    <el-dialog
      title="数据导出"
      :visible.sync="exportDialogVisible"
      width="500px"
      center
      :close-on-click-modal="false"
      append-to-body>
      <el-form
        ref="exportForm"
        :model="exportForm"
        :rules="exportFormRules"
        label-width="100px">
        <el-form-item label="用户">
          <el-input v-model="exportForm.username" disabled></el-input>
        </el-form-item>
        <el-form-item label="开始日期" prop="startDate">
          <el-date-picker
            v-model="exportForm.startDate"
            type="date"
            placeholder="选择开始日期"
            value-format="yyyy-MM-dd"
            style="width: 100%">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="结束日期" prop="endDate">
          <el-date-picker
            v-model="exportForm.endDate"
            type="date"
            placeholder="选择结束日期"
            value-format="yyyy-MM-dd"
            style="width: 100%">
          </el-date-picker>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="exportDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitExport" :loading="exportLoading">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 积分详情对话框 -->
    <el-dialog
      title="积分详情"
      :visible.sync="scoreDialogVisible"
      width="600px"
      center
      :close-on-click-modal="false"
      append-to-body>
      <div v-if="currentUserScore" class="score-detail">
        <div class="user-info">
          <h3>
            {{ currentUserScore.name }} ({{ currentUserScore.username }})
            <el-button 
              type="text" 
              icon="el-icon-data-analysis"
              @click="handleScoreTrend"
              style="margin-left: 10px; color: #409EFF;">
              积分分析
            </el-button>
          </h3>
        </div>
        
        <el-divider></el-divider>
        
        <div class="score-breakdown">
          <div class="score-item">
            <div class="score-label">
              <i class="el-icon-trophy"></i>
              参赛积分
            </div>
            <div class="score-value">{{ currentUserScore.game_score || 0 }}</div>
            <div class="score-desc">每参加一场比赛积分+1</div>
          </div>
          
          <div class="score-item">
            <div class="score-label">
              <i class="el-icon-check"></i>
              题目积分
            </div>
            <div class="score-value">{{ currentUserScore.question_score || 0 }}</div>
            <div class="score-desc">每AC一道题积分+1，AK额外+5</div>
          </div>
          
          <div class="score-item">
            <div class="score-label">
              <i class="el-icon-medal"></i>
              排名积分
            </div>
            <div class="score-value">{{ currentUserScore.rank_score || 0 }}</div>
            <div class="score-desc">前10%+1，前5%+2，前1%+3，第一名+5</div>
          </div>
          
          <div class="score-item">
            <div class="score-label">
              <i class="el-icon-edit"></i>
              订正积分
            </div>
            <div class="score-value">{{ currentUserScore.fix_score || 0 }}</div>
            <div class="score-desc">每订正一道题积分+1</div>
          </div>
          
          <div class="score-item">
            <div class="score-label">
              <i class="el-icon-video-camera"></i>
              复盘积分
            </div>
            <div class="score-value">{{ currentUserScore.replay_score || 0 }}</div>
            <div class="score-desc">每复盘一场比赛积分+2</div>
          </div>
          
          <div class="score-item">
            <div class="score-label">
              <i class="el-icon-document"></i>
              文章积分
            </div>
            <div class="score-value">{{ currentUserScore.article_score || 0 }}</div>
            <div class="score-desc">每一篇文章积分+2</div>
          </div>
        </div>
        
        <el-divider></el-divider>
        
        <div class="total-score">
          <div class="total-label">总积分</div>
          <div class="total-value">{{ currentUserScore.total_score || 0 }}</div>
        </div>
      </div>
      
      <div slot="footer" class="dialog-footer">
        <el-button @click="scoreDialogVisible = false">关 闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import request from '@/utils/request'
import axios from 'axios'

export default {
  name: 'User',
  data() {
    return {
      loading: false,
      userList: [],
      
      // 添加用户相关数据
      addDialogVisible: false,
      addForm: {
        username: '',
        password: '',
        name: '',
        sex: '1',
        birthday: '',
        role: 1
      },
      addFormRules: {
        username: [
          { required: true, message: '请输入用户名', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' }
        ],
        name: [
          { required: true, message: '请输入姓名', trigger: 'blur' }
        ],
        sex: [
          { required: true, message: '请选择性别', trigger: 'change' }
        ],
        birthday: [
          { required: true, message: '请选择生日', trigger: 'change' }
        ],
        role: [
          { required: true, message: '请选择角色', trigger: 'change' }
        ]
      },
      
      // 修改密码相关数据
      passwordDialogVisible: false,
      passwordForm: {
        userId: null,
        password: ''
      },
      passwordFormRules: {
        password: [
          { required: true, message: '请输入新密码', trigger: 'blur' }
        ]
      },
      
      // 积分相关数据
      scoreDialogVisible: false,
      currentUserScore: null,
      scoreList: [],
      
      // 编辑用户相关数据
      editDialogVisible: false,
      editForm: {
        id: null,
        username: '',
        name: '',
        sex: '1',
        birthday: '',
        role: 1
      },
      editFormRules: {
        name: [
          { required: true, message: '请输入姓名', trigger: 'blur' }
        ],
        sex: [
          { required: true, message: '请选择性别', trigger: 'change' }
        ],
        birthday: [
          { required: true, message: '请选择生日', trigger: 'change' }
        ],
        role: [
          { required: true, message: '请选择角色', trigger: 'change' }
        ]
      },
      
      // 数据导出相关数据
      exportDialogVisible: false,
      exportLoading: false,
      exportForm: {
        username: '',
        startDate: '',
        endDate: ''
      },
      exportFormRules: {
        startDate: [
          { required: true, message: '请选择开始日期', trigger: 'change' }
        ],
        endDate: [
          { required: true, message: '请选择结束日期', trigger: 'change' }
        ]
      }
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    // 获取用户列表
    async fetchData() {
      this.loading = true
      try {
        // 并行获取用户列表和积分数据
        const [userResponse, scoreResponse] = await Promise.all([
          request({
            url: '/api/user/list',
            method: 'get'
          }),
          request({
            url: '/api/user/score',
            method: 'get'
          })
        ])
        
        if (userResponse.code === 200) {
          this.userList = userResponse.data.items || []
        } else {
          throw new Error(userResponse.message || '获取用户列表失败')
        }
        
        if (scoreResponse.code === 200) {
          this.scoreList = scoreResponse.data.items || []
          // 将积分数据合并到用户列表中
          this.mergeScoreData()
        } else {
          console.warn('获取积分数据失败:', scoreResponse.message)
        }
      } catch (error) {
        console.error('获取用户列表失败:', error)
        this.$message.error(error.message || '获取用户列表失败')
      } finally {
        this.loading = false
      }
    },
    
    // 合并积分数据到用户列表
    mergeScoreData() {
      const scoreMap = {}
      this.scoreList.forEach(score => {
        scoreMap[score.username] = score
      })
      
      this.userList.forEach(user => {
        if (scoreMap[user.username]) {
          Object.assign(user, scoreMap[user.username])
        }
      })
    },
    
    // 添加用户相关方法
    handleAdd() {
      this.addForm = {
        username: '',
        password: '',
        name: '',
        sex: '1',
        birthday: '',
        role: 1
      }
      this.addDialogVisible = true
      this.$nextTick(() => {
        // 自动聚焦到用户名输入框
        setTimeout(() => {
          this.$refs.usernameInput && this.$refs.usernameInput.focus()
        }, 100)
      })
    },
    async submitAdd() {
      this.$refs.addForm.validate(async valid => {
        if (valid) {
          try {
            const response = await request({
              url: '/api/user/add',
              method: 'post',
              data: this.addForm
            })
            if (response.code === 200) {
              this.$message.success('添加用户成功')
              this.addDialogVisible = false
              this.fetchData()
            } else {
              this.$message.error(response.message || '添加用户失败')
            }
          } catch (error) {
            console.error('添加用户失败:', error)
            this.$message.error(error.message || '添加用户失败')
          }
        }
      })
    },
    
    // 修改密码相关方法
    handleEditPassword(row) {
      this.passwordForm = {
        userId: row.id,
        password: ''
      }
      this.passwordDialogVisible = true
      this.$nextTick(() => {
        // 自动聚焦到密码输入框
        setTimeout(() => {
          this.$refs.passwordInput && this.$refs.passwordInput.focus()
        }, 100)
      })
    },
    async submitPassword() {
      this.$refs.passwordForm.validate(async valid => {
        if (valid) {
          try {
            await request({
              url: `/api/user/${this.passwordForm.userId}/password`,
              method: 'put',
              data: { password: this.passwordForm.password }
            })
            this.$message.success('修改密码成功')
            this.passwordDialogVisible = false
          } catch (error) {
            console.error('修改密码失败:', error)
          }
        }
      })
    },
    
    // 更新用户状态
    async handleToggleStatus(row) {
      try {
        const newStatus = row.status === 1 ? 0 : 1
        const actionText = newStatus === 1 ? '启用' : '禁用'
        
        await this.$confirm(`确认要${actionText}该用户吗？`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        
        await request({
          url: `/api/user/${row.id}/status`,
          method: 'put',
          data: { status: newStatus }
        })
        
        this.$message.success(`${actionText}成功`)
        this.fetchData()
      } catch (error) {
        if (error !== 'cancel') {
          console.error('更新用户状态失败:', error)
        }
      }
    },
    
    // 删除用户
    async handleDelete(row) {
      try {
        await this.$confirm('确认要删除该用户吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        
        await request({
          url: `/api/user/${row.id}`,
          method: 'delete'
        })
        
        this.$message.success('删除成功')
        this.fetchData()
      } catch (error) {
        if (error !== 'cancel') {
          console.error('删除用户失败:', error)
        }
      }
    },
    
    // 编辑用户相关方法
    handleEdit(row) {
      this.editForm = {
        id: row.id,
        username: row.username,
        name: row.name,
        sex: row.sex,
        birthday: row.birthday,
        role: Number(row.role)
      }
      this.editDialogVisible = true
      this.$nextTick(() => {
        // 自动聚焦到姓名输入框
        setTimeout(() => {
          this.$refs.nameInput && this.$refs.nameInput.focus()
        }, 100)
      })
    },
    async submitEdit() {
      this.$refs.editForm.validate(async valid => {
        if (valid) {
          try {
            const submitData = {
              ...this.editForm,
              role: Number(this.editForm.role)
            }
            const response = await request({
              url: `/api/user/${this.editForm.id}`,
              method: 'put',
              data: submitData
            })
            if (response.code === 200) {
              this.$message.success('更新用户成功')
              this.editDialogVisible = false
              this.fetchData()
            } else {
              this.$message.error(response.message || '更新用户失败')
            }
          } catch (error) {
            console.error('更新用户失败:', error)
            this.$message.error(error.message || '更新用户失败')
          }
        }
      })
    },
    
    // 查看积分详情
    handleViewScore(row) {
      this.currentUserScore = row
      this.scoreDialogVisible = true
    },
    
    // 跳转到积分趋势分析
    handleScoreTrend() {
      this.$router.push({
        path: '/analysis/score-trend',
        query: {
          username: this.currentUserScore.username,
          name: this.currentUserScore.name
        }
      })
      this.scoreDialogVisible = false
    },
    
    // 数据导出相关方法
    handleExport(row) {
      this.exportForm = {
        username: row.username,
        startDate: '',
        endDate: ''
      }
      this.exportDialogVisible = true
      this.$nextTick(() => {
        this.$refs.exportForm && this.$refs.exportForm.clearValidate()
      })
    },
    async submitExport() {
      this.$refs.exportForm.validate(async valid => {
        if (valid) {
          // 验证日期范围
          if (this.exportForm.startDate > this.exportForm.endDate) {
            this.$message.error('开始日期不能大于结束日期')
            return
          }
          
          this.exportLoading = true
          try {
            // 直接使用axios来处理blob响应
            const response = await axios({
              url: '/api/user/export',
              method: 'get',
              params: {
                username: this.exportForm.username,
                start_date: this.exportForm.startDate,
                end_date: this.exportForm.endDate
              },
              responseType: 'blob',
              withCredentials: true
            })
            
            // 检查响应是否为错误
            if (response.headers['content-type'] && response.headers['content-type'].includes('application/json')) {
              // 如果是JSON响应，说明是错误
              const reader = new FileReader()
              reader.onload = () => {
                try {
                  const errorData = JSON.parse(reader.result)
                  this.$message.error(errorData.message || '数据导出失败')
                } catch (e) {
                  this.$message.error('数据导出失败')
                }
              }
              reader.readAsText(response.data)
              return
            }
            
            // 创建下载链接
            const blob = new Blob([response.data], { 
              type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' 
            })
            const url = window.URL.createObjectURL(blob)
            const link = document.createElement('a')
            link.href = url
            link.download = `用户数据导出_${this.exportForm.username}_${this.exportForm.startDate}_${this.exportForm.endDate}.xlsx`
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
            window.URL.revokeObjectURL(url)
            
            this.$message.success('数据导出成功')
            this.exportDialogVisible = false
          } catch (error) {
            console.error('数据导出失败:', error)
            this.$message.error(error.message || '数据导出失败')
          } finally {
            this.exportLoading = false
          }
        }
      })
    }
  }
}
</script>

<style scoped>
.filter-container {
  margin-bottom: 20px;
}

/* 弹窗垂直居中样式 */
:deep(.el-dialog) {
  margin-top: 0 !important;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
}

:deep(.el-dialog__header) {
  padding: 16px 20px;
  background-color: #f5f7fa;
  border-bottom: 1px solid #e4e7ed;
}

:deep(.el-dialog__title) {
  font-size: 16px;
  font-weight: 600;
  color: #303133;
}

:deep(.el-dialog__body) {
  padding: 20px 20px 10px;
}

:deep(.el-dialog__footer) {
  padding: 10px 20px 16px;
  border-top: 1px solid #f0f0f0;
}

/* 积分详情样式 */
.score-detail {
  padding: 10px 0;
}

.user-info {
  text-align: center;
  margin-bottom: 20px;
}

.user-info h3 {
  margin: 0;
  color: #303133;
  font-size: 18px;
}

.score-breakdown {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
  margin-bottom: 20px;
}

.score-item {
  background: #f8f9fa;
  border-radius: 8px;
  padding: 16px;
  text-align: center;
  border: 1px solid #e9ecef;
}

.score-label {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  color: #606266;
  margin-bottom: 8px;
}

.score-label i {
  margin-right: 6px;
  font-size: 16px;
  color: #409EFF;
}

.score-value {
  font-size: 24px;
  font-weight: bold;
  color: #303133;
  margin-bottom: 4px;
}

.score-desc {
  font-size: 12px;
  color: #909399;
  line-height: 1.4;
}

.total-score {
  background: linear-gradient(135deg, #409EFF, #67C23A);
  color: white;
  border-radius: 12px;
  padding: 20px;
  text-align: center;
  margin-top: 20px;
}

.total-label {
  font-size: 16px;
  margin-bottom: 8px;
  opacity: 0.9;
}

.total-value {
  font-size: 32px;
  font-weight: bold;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .score-breakdown {
    grid-template-columns: 1fr;
    gap: 12px;
  }
  
  .score-item {
    padding: 12px;
  }
  
  .score-value {
    font-size: 20px;
  }
  
  .total-value {
    font-size: 28px;
  }
}
</style> 